import * as Yup from "yup";
const generateValidationSchema = (fields) => {
  const validationRules = {};
  fields.forEach((field) => {
    switch (field) {
      case "email":
        validationRules.email = Yup.string()
          .email("Invalid email format")
          .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in)$/,
            "Only .com and .in domains are allowed"
          )
          .required("Email is Required");
        break;
      case "signup_password":
        validationRules.signup_password = Yup.string().required(
          "Password is Required"
        );
        break;
      case "confrim_password":
        validationRules.confrim_password = Yup.string()
          .oneOf([Yup.ref("signup_password"), null], "Passwords must match")
          .required("Confirm Password is Required");
        break;
      case "password":
        validationRules.password = Yup.string().required(
          "Password is Required"
        );
        break;
      case "Clinic_Hospital_Name":
        validationRules.Clinic_Hospital_Name = Yup.string().required(
          "HospitalName is Required"
        );
        break;
      case "Clinic_Hospital_ID":
        validationRules.Clinic_Hospital_ID = Yup.string().required(
          "HospitalID is Required"
        );
        break;
      case "fullname":
  validationRules.fullname = Yup.string()
    .required("Full Name is Required");
  break;

      case "gender":
        validationRules.gender = Yup.string().required("Gender is Required");
        break;
      case "dateofbirth":
        validationRules.dateofbirth = Yup.string().required(
          "Date of Birth is Required"
        );
        break;
      case "phonenumber":
        validationRules.phonenumber = Yup.string()
    .min(12, "Must be 10 digits").required(
          "Phone Number is Required"
        );
        break;
      case "primaryphonenumber":
        validationRules.primaryphonenumber = Yup.string()
    .min(12, "Must be 10 digits").required(
          "Phone Number is Required"
        );
        break;
      case "emergencycontactnumber":
        validationRules.emergencycontactnumber = Yup.string().min(12, "Must be 10 digits").required(
          "Emergency Number is Required"
        );
        break;
      case "specialization":
        validationRules.specialization = Yup.array()
          .min(1, "Please select at least one specialization")
          .of(Yup.string().required())
          .required("Specialization is Required");
        break;
      case "yearsofexperience":
        validationRules.yearsofexperience = Yup.string().required(
          "Years of Experience is Required"
        );
        break;
      case "medicallicensenumber":
        validationRules.medicallicensenumber = Yup.string().required(
          "Medical License Number is Required"
        );
        break;
      case "professionalaffiliations":
        validationRules.professionalaffiliations = Yup.string().required(
          "Professional Affiliations is Required"
        );
        break;
      case "consultationdays":
        validationRules.consultationdays = Yup.string().required(
          "ConsultatiOnDays is Required"
        );
        break;
      case "availablehours":
        validationRules.availablehours = Yup.string().required(
          "AvailableHours is Required"
        );
        break;
      case "oncallavailability":
        validationRules.oncallavailability = Yup.string().required(
          "OnCallAvailability is Required"
        );
        break;
      case "preferredappointmentduration":
        validationRules.preferredappointmentduration = Yup.string().required(
          "PreferredAppointmentDuration is Required"
        );
        break;
      case "languagesknown":
        validationRules.languagesknown = Yup.array()
          .min(1, "Please select at least one language")
          .of(Yup.string().required())
          .required("Languages known is required");
        break;
      case "starttime":
        validationRules.starttime = Yup.string().required(
          "StartTime is required"
        );
        break;
      case "endtime":
        validationRules.endtime = Yup.string().required("EndTime is required");
        break;
      case "monthly":
        validationRules.monthly = Yup.string().required("Monthly is required");
        break;
      case "weekly":
        validationRules.weekly = Yup.string().required("Weekly is required");
        break;
      case "days":
        validationRules.days = Yup.string().required("Days is required");
        break;
      case "medicalschlattended":
        validationRules.medicalschlattended = Yup.string().required(
          "Medical School Attended is required"
        );
        break;
      case "degreesearned":
        validationRules.degreesearned = Yup.string().required(
          "Degrees Earned is required"
        );
        break;
      case "additionalcertification":
        validationRules.additionalcertification = Yup.string().required(
          "Additional Certifications is required"
        );
        break;
      case "residencydetails":
        validationRules.residencydetails = Yup.string().required(
          "Residency Details is required"
        );
        break;
      case "qualification":
        validationRules.qualification = Yup.array()
          .of(Yup.string().required("Qualification cannot be empty")) // Ensure each entry is a valid string
          .min(1, "At least one qualification is required"); // Ensure at least one item is present
        break;
      case "primaryrole":
        validationRules.primaryrole = Yup.string().required(
          "Primary Role is required"
        );
        break;
      case "subspecility":
        validationRules.subspecility = Yup.string().required(
          "Subspecialty is required"
        );
        break;
      case "procedureperformed":
        validationRules.procedureperformed = Yup.string().required(
          "Procedures Performed is required"
        );
        break;
      // case "patientid":
      //   validationRules.patientid = Yup.string().required(
      //     "PatientId is required"
      //   );
      //   break;
      case "age":
        validationRules.age = Yup.string().required("Age is Required");
        break;
      case "martialstatus":
        validationRules.martialstatus = Yup.string().required(
          "Martial Status is Required"
        );
        break;
      case "address":
        validationRules.address = Yup.string().required("Address is required");
        break;
      case "emergencycontactname":
        validationRules.emergencycontactname = Yup.string().required(
          "Emergency ContactName is Required"
        );
        break;
      case "relationtopatient":
        validationRules.relationtopatient = Yup.string().required(
          "Relation to patient is Required"
        );
        break;
      case "addmissiontype":
        validationRules.addmissiontype = Yup.string().required(
          "Addmission Type is Required"
        );
        break;
      case "primarydiagnosis":
        validationRules.primarydiagnosis = Yup.string().required(
          "Primary Diagnosis is required"
        );
        break;
      case "symptons":
        validationRules.symptons = Yup.string().required(
          "Symptons is required"
        );
        break;
      case "allergiesifany":
        validationRules.allergiesifany = Yup.string().required(
          "Allergies is Required"
        );
        break;
      case "existingmedicalconditions":
        validationRules.existingmedicalconditions = Yup.string().required(
          "Existing Medical Conditions is Required"
        );
        break;
      case "assigneddoctor":
        validationRules.assigneddoctor = Yup.string().required(
          "Assigned Doctor is required"
        );
        break;
      case "treatmentplansummary":
        validationRules.treatmentplansummary = Yup.string().required(
          "Treatment Plan Summary is required"
        );
        break;
      case "medicationsprescribed":
        validationRules.medicationsprescribed = Yup.string().required(
          "Medications Prescribed is required"
        );
        break;
      case "labdiagnostictestsordered":
        validationRules.labdiagnostictestsordered = Yup.string().required(
          "Lab/Diagnostic Tests Ordered is required"
        );
        break;
      case "roomwardnumber":
        validationRules.roomwardnumber = Yup.string().required(
          "Room/Ward Number is required"
        );
        break;
      case "dateofadmissionvisit":
        validationRules.dateofadmissionvisit = Yup.string().required(
          "Date of Admissionvisit is Required"
        );
        break;
      case "expecteddischarge":
        validationRules.expecteddischarge = Yup.string().required(
          "Expected Discharge Date is Required"
        );
        break;
      case "followupappointmentdate":
        validationRules.followupappointmentdate = Yup.string().required(
          "Followup Appointmentdate is Required"
        );
        break;
      case "insuranceprovider":
        validationRules.insuranceprovider = Yup.string().required(
          "Insurance Provider is required"
        );
        break;
      case "insurancepolicynumber":
        validationRules.insurancepolicynumber = Yup.string().required(
          "Insurance Policy Number is required"
        );
        break;
      case "billingstatus":
        validationRules.billingstatus = Yup.string().required(
          "Billing Status is required"
        );
        break;
      case "paymentmethod":
        validationRules.paymentmethod = Yup.string().required(
          "Payment Method is required"
        );
        break;
      case "typeOfFacility":
        validationRules.typeOfFacility = Yup.string().required(
          "Type Of Facility is required"
        );
        break;
      case "secondaryPhoneNumber":
        validationRules.secondaryPhoneNumber = Yup.string().min(12, "Must be 10 digits").required(
          "Secondary Phone Number is required"
        );
        break;
      case "websiteURL":
        validationRules.websiteURL = Yup.string().required(
          "WebsiteURL is required"
        );
        break;
      case "addressLine2":
        validationRules.addressLine2 = Yup.string().required(
          "Address Line 2 is required"
        );
        break;
      case "city":
        validationRules.city = Yup.string().required("City is required");
        break;
      case "state":
        validationRules.state = Yup.string().required("State is required");
        break;
      case "zipCode":
        validationRules.zipCode = Yup.string().required("ZipCode is required");
        break;
      case "country":
        validationRules.country = Yup.string().required(
          "Country is required"
        );
        break;
      case "contactName":
        validationRules.contactName = Yup.string().required(
          "Contact Name is required"
        );
        break;
      case "contactTitle":
        validationRules.contactTitle = Yup.string().required(
          "Contact Title is required"
        );
        break;
      case "primaryContactPhoneNumber":
        validationRules.primaryContactPhoneNumber = Yup.string().min(12, "Must be 10 digits").required(
          "Primary Contact PhoneNumber is required"
        );
        break;
      case "secondaryContactPhoneNumber":
        validationRules.secondaryContactPhoneNumber = Yup.string().min(12, "Must be 10 digits").required(
          "Secondary Contact PhoneNumber is required"
        );
        break;
      case "contactEmailAddress":
        validationRules.contactEmailAddress = Yup.string().required(
          "Contact Email Address is required"
        );
        break;
      case "Modules":
        validationRules.Modules =  Yup.array()
  .min(1, "Select at least one module")
  .required("Modules is required");
        break;
      case "SubscriptionType":
        validationRules.SubscriptionType = Yup.string().required(
          "Subscription Type is required"
        );
        break;
      case "SubscriptionStartDate":
        validationRules.SubscriptionStartDate = Yup.string().required(
          "Subscription Start Date is required"
        );
        break;
      case "SubscriptionEndDate":
        validationRules.SubscriptionEndDate = Yup.string().required(
          "Subscription End Date is required"
        );
        break;
      case "licenseNumberorAccreditationID":
        validationRules.licenseNumberorAccreditationID = Yup.string().required(
          "LicenseNumberorAccreditationID is required"
        );
        break;
      case "insuranceProvidersAssociated":
        validationRules.insuranceProvidersAssociated = Yup.string().required(
          "InsuranceProvidersAssociated is required"
        );
        break;
      case "taxIdentificationNumber_TIN":
        validationRules.taxIdentificationNumber_TIN = Yup.string().required(
          "TaxIdentificationNumber_TIN is required"
        );
        break;
      case "dateofEstablishment":
        validationRules.dateofEstablishment = Yup.string().required(
          "DateofEstablishment is required"
        );
        break;
      case "emergencyContactInformation":
        validationRules.emergencyContactInformation = Yup.string().required(
          "EmergencyContactInformation is required"
        );
        break;
      case "specialRequirementsorNotes":
        validationRules.specialRequirementsorNotes = Yup.string().required(
          "SpecialRequirementsorNotes is required"
        );
        break;
      case "preferredCommunicationMode":
        validationRules.preferredCommunicationMode = Yup.string().required(
          "PreferredCommunicationMode is required"
        );
        break;
      case "statusofModules":
        validationRules.statusofModules = Yup.string().required(
          "StatusofModules is required"
        );
        break;
      case "upgradeEligibility":
        validationRules.upgradeEligibility = Yup.string().required(
          "UpgradeEligibility is required"
        );
        break;
      case "roleName":
        validationRules.roleName = Yup.string().required(
          "RoleName is required"
        );
        break;

      case "refferedby":
        validationRules.refferedby = Yup.string().required(
          "Refferal is required"
        );
        break;

      case "Eductioncertificates":
        validationRules.Eductioncertificates = Yup.array()
          .of(
            Yup.object({
              highestQualification: Yup.string().required(
                "Qualification is Required"
              ),
              university: Yup.string().required("University Name is Required"),
              fieldofstudy: Yup.string().required("Field of Study is Required"),
              endDate: Yup.string().required("End Date is Required"),
            })
          )
          .min(1, "At least one education entry is required")
          .required("Education is required");
        break;

      case "bloodgroup":
        validationRules.bloodgroup = Yup.string().required(
          "Blood Group is Required"
        );
        break;

      case "bloodpressure":
        validationRules.bloodpressure = Yup.string()
          .typeError("Blood Pressure must be a number")
          .required("Blood Pressure is Required");
        break;

      case "weight":
        validationRules.weight = Yup.number()
          .typeError("Weight must be a number")
          .required("Weight is Required");
        break;

      case "height":
        validationRules.height = Yup.number()
          .typeError("Height must be a number")
          .required("Height is Required");
        break;

      case "pulse":
        validationRules.pulse = Yup.number()
          .typeError("Pulse Rate must be a number")
          .required("Pulse Rate is Required");
        break;

      case "temparature":
        validationRules.temparature = Yup.number()
          .typeError("Temperature must be a number")
          .required("Temperature is Required");
        break;

        case "status":
        validationRules.status = Yup.string().required(
          "Status is required"
        );
        break;

         case "Medicineid":
        validationRules.status = Yup.string().required(
          "Medicine Id is required"
        );
        break;

         case "Medicinename":
        validationRules.status = Yup.string().required(
          "Medicinename is required"
        );
        break;
         case "name":
        validationRules.name = Yup.string().required(
          "Signature is required"
        );
        break;

      default:
        break;
    }
  });
  return Yup.object(validationRules);
};
const initialValues = {
  email: "",
  password: "",
  signup_password: "",
  confrim_password: "",
  Clinic_Hospital_Name: "",
  Clinic_Hospital_ID: "",
  fullname: "",
  gender: "",
  dateofbirth: "",
  phonenumber: "",
  address: "",
  emergencycontactnumber: "",
  specialization: "",
  yearsofexperience: "",
  medicallicensenumber: "",
  professionalaffiliations: "",
  consultationdays: "",
  availablehours: "",
  oncallavailability: "",
  preferredappointmentduration: "",
  languagesknown: "",
  starttime: "",
  endtime: "",
  monthly: "",
  weekly: "",
  days: "",
  medicalschlattended: "",
  degreesearned: "",
  additionalcertification: "",
  residencydetails: "",
  qualification: "",
  primaryrole: "",
  subspecility: "",
  procedureperformed: "",
  patientid: "",
  age: "",
  martialstatus: "",
  emergencycontactname: "",
  relationtopatient: "",
  addmissiontype: "",
  primarydiagnosis: "",
  symptons: "",
  allergiesifany: "",
  existingmedicalconditions: "",
  assigneddoctor: "",
  treatmentplansummary: "",
  medicationsprescribed: "",
  labdiagnostictestsordered: "",
  roomwardnumber: "",
  dateofadmissionvisit: "",
  expecteddischarge: "",
  followupappointmentdate: "",
  insuranceprovider: "",
  insurancepolicynumber: "",
  billingstatus: "",
  paymentmethod: "",
  typeOfFacility: "",
  secondaryPhoneNumber: "",
  websiteURL: "",
  addressLine2: "",
  city: "",
  state: "",
  zipCode: "",
  country: "",
  contactName: "",
  contactTitle: "",
  primaryContactPhoneNumber: "",
  secondaryContactPhoneNumber: "",
  contactEmailAddress: "",
  Modules: "",
  SubscriptionType: "",
  SubscriptionStartDate: "",
  SubscriptionEndDate: "",
  licenseNumberorAccreditationID: "",
  insuranceProvidersAssociated: "",
  taxIdentificationNumber_TIN: "",
  dateofEstablishment: "",
  emergencyContactInformation: "",
  specialRequirementsorNotes: "",
  preferredCommunicationMode: "",
  statusofModules: "",
  upgradeEligibility: "",
  roleName: "",
  Eductioncertificates: [],
  refferedby: "",
  bloodgroup: "",
  bloodpressure: "",
  weight: "",
  height: "",
  pulse: "",
  temparature: "",
  status:"",
  Medicineid:'',
  Medicineidname:'',
  name:"",
  primaryphonenumber:""
};
export { initialValues, generateValidationSchema };
